<template>
  <section>
    <v-container id="container" fluid>
      <v-row id="gr" align="center" justify="center" class="pt-5 pt-md-15">
        <v-col cols="12" md="8" class="pt-5 pt-md-15">
          <v-container class="fill-height">
            <v-row justify="left" class="mb-5">
              <v-col cols="11" class="py-0 mt-10 ml-md-5">
                <div class="d-inline-flex">
                  <v-img
                    contain
                    height="50"
                    class="d-flex align-left mr-n15 mb-5 pa-0"
                    src="@/assets/logos/horz/gr.svg"
                  ></v-img>
                </div>
                <div>
                  {{ $t("proyectos.generarecetas") }}
                </div>
                <br>
                <div>
                  {{ $t("proyectos.generarecetas1") }}
                </div>
                <v-btn
                  href="http://generarecetas.com"
                  target="_blank"
                  class="accent my-5"
                  >{{ $t("info.verSitio") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col
          cols="12"
          md="4"
          align-self="center"
          class="pt-5 pt-md-15 shape verdeFondo"
        >
          <v-img
            contain
            height="300"
            src="@/assets/img/proyectos/gr/screen-gr.png"
          >
          </v-img>
        </v-col>
        <div class="my-10">
          <v-btn outlined class="ma-2" to="/ebersy"
            >Ebersy<v-icon right>
              mdi-chevron-left
            </v-icon></v-btn
          >
          <v-btn outlined class="ma-2" to="/psi"
            ><v-icon left> mdi-chevron-right </v-icon>PSI</v-btn
          >
        </div>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Generarecetas",
};
</script>

<style scoped>
#gr {
  min-height: 100vh;
}

.shape {
  border-radius: 30% 70% 67% 33% / 30% 30% 70% 70%;
  background-position: top right;
  width: 200px;
  padding: 15px 0px 0px 0px
}
</style>
